export enum Colors {
    Past = '#EAEAEA', //  grey
    Present = '#FDE53E', //  yellow
    Future = '#FFFFFF', //  white
}
  